import { dateColumn } from '../../../services/DateService';
import { currencyColumn } from '../../../services/NumberService';
import { textColumn, textComparator } from '../../../services/StringService';
import DownloadDocumentButton from './DownloadDocumentButton';
import OpenDDEventLink from './OpenDDEventLink';
import OpenManagerNotesLink from './OpenManagerNotesLink';
import OpenManagerStrategy from './OpenManagerStrategy';
import OpenManagerSummary from './OpenManagerSummary';
import OpenMeetingNotesLink from './OpenMeetingNotesLink';
import OpenPlanLink from './OpenPlanLink';
import OpenBackstopLink from './OpenBackstopLink';

const downloadIconColumnDef = {
  maxWidth: 35,
  suppressHeaderMenuButton: true,
  suppressHeaderFilterButton: true,
  suppressMovable: true,
  sortable: false,
  resizable: false,
};

export const researchFileModeColumnDefs = [
  {
    suppressHeaderFilterButton: false,
    suppressHeaderMenuButton: false,
    cellRenderer: DownloadDocumentButton,
    ...downloadIconColumnDef,
  },
  {
    field: 'title',
    headerName: 'File Name',
    ...textColumn,
    minWidth: 100,
  },
  {
    field: 'deliverableType',
    headerName: 'Document Type',
    ...textColumn,
  },
  {
    field: 'publishedDate',
    headerName: 'Published Date',
    sort: 'desc',
    ...dateColumn,
    width: 180,
  },
];

export const clientFileModeColumnDefs = [
  {
    suppressHeaderFilterButton: false,
    suppressHeaderMenuButton: false,
    cellRenderer: DownloadDocumentButton,
    ...downloadIconColumnDef,
  },
  {
    field: 'title',
    headerName: 'File Name',
    ...textColumn,
    minWidth: 100,
  },
  {
    field: 'deliverableType',
    headerName: 'Document Type',
    ...textColumn,
  },
  {
    field: 'asOfDate',
    headerName: 'As Of Date',
    minWidth: 160,
    ...dateColumn,
  },
  {
    field: 'publishedDate',
    headerName: 'Published Date',
    ...dateColumn,
    width: 180,
  },
];

export const privateMarketColumnDefs = [
  {
    suppressHeaderFilterButton: false,
    suppressHeaderMenuButton: false,
    cellRenderer: DownloadDocumentButton,
    ...downloadIconColumnDef,
  },
  // {
  //   field: 'docName',
  //   headerName: 'Document Name',
  //   ...textColumn,
  //   minWidth: 100,
  // },
  {
    field: 'investmentFirmFilter',
    headerName: 'Investment Firm',
    ...textColumn,
    minWidth: 100,
  },
  {
    field: 'vehicleNEPCShortCode',
    headerName: 'Investible Vehicle',
    ...textColumn,
  },
  {
    field: 'managerDocumentType',
    headerName: 'Manager Document Type',
    valueFormatter: (props) => {
      return props?.value?.join(', ');
    },
    comparator: textComparator,
  },
  {
    field: 'asOfDate',
    headerName: 'As Of Date',
    sort: 'desc',
    minWidth: 160,
    ...dateColumn,
  },
];

export const meetingNotesColumnDefs = [
  {
    suppressHeaderFilterButton: true,
    suppressHeaderMenuButton: false,
    field: 'firm',
    headerName: 'Investment Firm',
    cellRenderer: OpenManagerSummary,
    ...textColumn,
    minWidth: 100,
  },
  {
    field: 'subject',
    headerName: 'Meeting Subject',
    cellRenderer: OpenMeetingNotesLink,
    ...textColumn,
    minWidth: 100,
  },
  {
    field: 'meetingDate',
    headerName: 'Meeting Date',
    width: 100,
    sort: 'desc',
    ...dateColumn,
  },
];

export const managerNotesColumnDefs = [
  {
    field: 'subject',
    headerName: 'Subject',
    cellRenderer: OpenManagerNotesLink,
    suppressHeaderFilterButton: true,
    suppressHeaderMenuButton: false,
    ...textColumn,
    minWidth: 120,
  },
  {
    field: 'category',
    headerName: 'Category',
    minWidth: 80,
    maxWidth: 250,
    ...textColumn,
  },
  {
    field: 'firm',
    headerName: 'Investment Firm',
    ...textColumn,
    minWidth: 100,
  },
  {
    field: 'date',
    headerName: 'Date',
    width: 100,
    sort: 'desc',
    ...dateColumn,
  },
  {
    field: 'newStatus',
    headerName: 'New Status',
    minWidth: 100,
    ...textColumn,
  },
];

export const focusedPlacementListsColumnDefs = [
  {
    field: 'investmentStrategyName',
    headerName: 'Strategy Name',
    cellRenderer: OpenManagerStrategy,
    ...textColumn,
    minWidth: 280,
    maxWidth: 540,
    flex: 1,
    suppressSizeToFit: true,
    suppressHeaderMenuButton: false,
    suppressHeaderFilterButton: true,
  },
  {
    field: 'investmentFirmName',
    headerName: 'Investment Firm',
    flex: 1,
    ...textColumn,
    minWidth: 250,
    maxWidth: 260,
  },
  {
    field: 'dueDiligenceRating',
    headerName: 'Due Diligence Rating',
    minWidth: 120,
    maxWidth: 145,
    suppressSizeToFit: true,
    sort: 'asc',
  },
];

export const focusedPlacementListEndColumnDefs = [
  {
    field: 'fplListName',
    headerName: 'Strategy Group',
    flex: 1,
    ...textColumn,
    minWidth: 250,
    maxWidth: 260,
  },
  {
    field: 'assetClass',
    headerName: 'Asset Class',
    ...textColumn,
    minWidth: 200,
    maxWidth: 550,
  },
  {
    field: 'betaGroup',
    headerName: 'Asset Group',
    ...textColumn,
    minWidth: 135,
  },
];

export const focusedPlacementListColumnDefs = [
  {
    suppressHeaderFilterButton: false,
    suppressHeaderMenuButton: false,
    field: 'investmentFirmName',
    headerName: 'Investment Firm',
    sort: 'asc',
    cellRenderer: OpenManagerSummary,
    flex: 1,
    ...textColumn,
    minWidth: 100,
  },
  {
    field: 'investmentStrategyName',
    headerName: 'Investment Strategy',
    cellRenderer: OpenManagerStrategy,
    ...textColumn,
    minWidth: 100,
  },
  {
    field: 'dueDiligenceRating',
    headerName: 'Due Diligence Rating',
    width: 175,
    suppressSizeToFit: true,
  },
  {
    field: 'strategyDueDiligenceStatus',
    headerName: 'Due Diligence Status',
    ...textColumn,
    width: 175,
    suppressSizeToFit: true,
  },
  {
    field: 'esgRating',
    headerName: 'ESG Rating',
    minWidth: 100,
    suppressSizeToFit: true,
  },
  {
    field: 'diverseOwnedLed',
    headerName: 'Diverse',
    minWidth: 100,
    suppressSizeToFit: true,
  },
];

export const fplResearchModeColumnDefs = [
  {
    suppressHeaderFilterButton: false,
    suppressHeaderMenuButton: false,
    field: 'subject',
    headerName: 'Subject',
    cellRenderer: OpenMeetingNotesLink,
    ...textColumn,
    minWidth: 100,
  },
  {
    field: 'meetingDate',
    headerName: 'Date',
    sort: 'desc',
    minWidth: 100,
    ...dateColumn,
  },
];

const baseDDColumnDefs = [
  {
    suppressHeaderFilterButton: false,
    suppressHeaderMenuButton: false,
    field: 'ddSubcategory',
    headerName: 'Subcategory',
    ...textColumn,
    width: 109,
    minWidth: 109,
    maxWidth: 200,
    flex: 1,
  },
  {
    field: 'eventDate',
    headerName: 'Date',
    sort: 'desc',
    width: 120,
    ...dateColumn,
  },
  {
    field: 'firmDueDiligenceStatus',
    headerName: 'Status Change',
    width: 150,
    ...textColumn,
    suppressSizeToFit: true,
  },
  {
    field: 'levelOfImpact',
    headerName: 'Level of Impact',
    ...textColumn,
    width: 150,
  },
];

const lockedColumn = {
  suppressMovable: true,
  sortable: false,
  suppressHeaderMenuButton: true,
  suppressHeaderFilterButton: true,
  resizable: false,
};

export const baseEndColumns = [
  {
    field: 'liquidityName',
    headerName: 'Liquidity',
    width: 144,
    minWidth: 100,
    maxWidth: 400,
    suppressHeaderMenuButton: true,
    suppressHeaderFilterButton: true,
    suppressSizeToFit: true,
  },
  {
    field: 'assetValue',
    headerName: 'Asset Value',
    type: 'rightAligned',
    headerClass: 'ag-header-cell-text-right',
    ...currencyColumn,
    width: 160,
    minWidth: 160,
    maxWidth: 400,
    aggFunc: 'sum',
    ...lockedColumn,
  },
  {
    field: 'assetDate',
    headerName: 'As Of Date',
    width: 110,
    minWidth: 110,
    maxWidth: 110,
    ...dateColumn,
    ...lockedColumn,
  },
];

export const baseEndColumnsAssetGroup = [
  {
    field: 'liquidityName',
    headerName: 'Liquidity',
    width: 144,
    minWidth: 100,
    maxWidth: 400,
    suppressHeaderMenuButton: true,
    suppressHeaderFilterButton: true,
    suppressSizeToFit: true,
  },
  {
    field: 'inheritedPortfolioName',
    headerName: 'Legal Entity',
    ...textColumn,
    flex: 5,
    minWidth: 100,
    maxWidth: 400,
    tooltipField: 'assetGroupChain',
    tooltipShowDelay: 0,
    hide: false,
    suppressHeaderMenuButton: true,
    suppressHeaderFilterButton: true,
  },
  {
    field: 'assetValue',
    headerName: 'Asset Value',
    type: 'rightAligned',
    headerClass: 'ag-header-cell-text-right',
    ...currencyColumn,
    width: 160,
    minWidth: 160,
    maxWidth: 400,
    aggFunc: 'sum',
    ...lockedColumn,
  },
  {
    field: 'assetDate',
    headerName: 'As Of Date',
    width: 110,
    minWidth: 110,
    maxWidth: 110,
    ...dateColumn,
    ...lockedColumn,
  },
];

export const ddratingColumn = {
  field: 'ddRating',
  headerName: 'Due Diligence Rating',
  headerClass: 'rating-header',
  cellClass: 'rating-cell',
  width: 80,
  suppressHeaderMenuButton: true,
  suppressHeaderFilterButton: true,
};

const ddRatingAsChildColumn = {
  field: 'ddRating',
  headerName: 'Due Diligence',
  headerClass: 'rating-header',
  cellClass: 'rating-cell',
  suppressHeaderMenuButton: true,
  suppressHeaderFilterButton: true,
  width: 125,
  maxWidth: 125,
  minWidth: 125,
};

export const baseRatingColumnDefs = [
  {
    suppressHeaderFilterButton: false,
    suppressHeaderMenuButton: false,
    headerName: 'Ratings',
    headerClass: 'rating-header',
    children: [ddRatingAsChildColumn],
  },
  {
    field: 'diverseOwnedLed',
    headerName: 'Diverse',
    headerClass: 'rating-header',
    width: 100,
    maxWidth: 100,
    suppressHeaderMenuButton: true,
    suppressHeaderFilterButton: true,
    suppressSizeToFit: true,
  },
];

export const esgChildrenColumn = {
  field: 'esgRating',
  headerName: 'ESG',
  headerClass: 'rating-header',
  cellClass: 'rating-cell',
  width: 70,
  maxWidth: 70,
  minWidth: 70,
  flex: 2,
  suppressHeaderMenuButton: true,
  suppressHeaderFilterButton: true,
  suppressSizeToFit: true,
};

export const diverseColumn = {
  field: 'diverseOwnedLed',
  headerName: 'Diverse',
  headerClass: 'rating-header',
  width: 100,
  maxWidth: 100,
  suppressHeaderMenuButton: true,
  suppressHeaderFilterButton: true,
  suppressSizeToFit: true,
};

export const deiChildrenColumn = {
  field: 'deiRating',
  headerName: 'DEI',
  headerClass: 'rating-header',
  cellClass: 'rating-cell',
  width: 60,
  maxWidth: 60,
  minWidth: 60,
  flex: 2,
  suppressHeaderMenuButton: true,
  suppressHeaderFilterButton: true,
  suppressSizeToFit: true,
};

export const myManagersAssetColumnDefs = [
  {
    suppressHeaderFilterButton: true,
    suppressHeaderMenuButton: false,
    field: 'assetType',
    headerName: 'Asset Class',
    rowGroup: true,
    maxWidth: 220,
    hide: true,
    ...textColumn,
  },
  {
    suppressHeaderFilterButton: true,
    suppressHeaderMenuButton: false,
    field: 'strategyName',
    headerName: 'Strategy',
    cellRenderer: OpenManagerStrategy,
    ...textColumn,
    sort: `asc`,
    minWidth: 300,
    resizable: true,
    flex: 1,
  },
  {
    field: 'firmName',
    headerName: 'Manager',
    ...textColumn,
    flex: 5,
    minWidth: 300,
    hide: true,
    suppressHeaderMenuButton: true,
    suppressHeaderFilterButton: true,
  },
];

export const myManagersAssetColumnDefsAssetGroup = [
  {
    suppressHeaderFilterButton: true,
    suppressHeaderMenuButton: false,
    field: 'assetType',
    headerName: 'Asset Class',
    rowGroup: true,
    maxWidth: 220,
    hide: true,
    ...textColumn,
  },
  {
    suppressHeaderFilterButton: true,
    suppressHeaderMenuButton: false,
    field: 'strategyName',
    headerName: 'Strategy',
    cellRenderer: OpenManagerStrategy,
    ...textColumn,
    sort: `asc`,
    minWidth: 300,
    resizable: true,
    rowGroup: true,
    hide: true,
    flex: 1,
  },
  {
    field: 'firmName',
    headerName: 'Manager',
    ...textColumn,
    flex: 5,
    minWidth: 300,
    hide: true,
    suppressHeaderMenuButton: true,
    suppressHeaderFilterButton: true,
  },
];

export const myManagersDDColumnDefs = [
  {
    suppressHeaderFilterButton: false,
    suppressHeaderMenuButton: false,
    field: 'investmentFirmName',
    headerName: 'Investment Firm',
    cellRenderer: OpenManagerSummary,
    ...textColumn,
    minWidth: 180,
  },
  {
    field: 'eventTitle',
    headerName: 'Event Title',
    width: 250,
    cellRenderer: OpenDDEventLink,
    ...textColumn,
    suppressSizeToFit: true,
  },
  ...baseDDColumnDefs,
];

export const managerDDEventsColumnDefs = [
  {
    suppressHeaderFilterButton: false,
    suppressHeaderMenuButton: false,
    field: 'eventTitle',
    headerName: 'Event',
    cellRenderer: OpenDDEventLink,
    ...textColumn,
    minWidth: 100,
  },
  ...baseDDColumnDefs,
];

export const esgDeiColumnDefs = [
  {
    field: 'esgRating',
    headerName: 'ESG Rating',
    minWidth: 115,
    maxWidth: 125,
    suppressSizeToFit: true,
  },
  {
    field: 'deiRating',
    headerName: 'DEI Rating',
    minWidth: 115,
    maxWidth: 125,
    flex: 2,
    suppressSizeToFit: true,
  },
  {
    field: 'diverseOwnedLed',
    headerName: 'Diverse',
    minWidth: 90,
    suppressSizeToFit: true,
  },
];

export const managerStrategiesColumnDefs = [
  {
    suppressHeaderFilterButton: false,
    suppressHeaderMenuButton: false,
    field: 'investmentStrategyName',
    headerName: 'Strategy Name',
    cellRenderer: OpenManagerStrategy,
    sort: 'asc',
    ...textColumn,
    minWidth: 280,
    maxWidth: 540,
    flex: 1,
    suppressSizeToFit: true,
  },
  {
    field: 'dueDiligenceRating',
    headerName: 'Due Diligence Rating',
    minWidth: 120,
    maxWidth: 145,
    suppressSizeToFit: true,
  },
  {
    field: 'fplListName',
    headerName: 'Strategy Group',
    flex: 1,
    ...textColumn,
    minWidth: 250,
    maxWidth: 260,
  },
  {
    field: 'assetClass',
    headerName: 'Asset Class',
    ...textColumn,
    minWidth: 200,
    maxWidth: 550,
  },
  {
    field: 'betaGroup',
    headerName: 'Asset Group',
    ...textColumn,
    minWidth: 135,
    maxWidth: 150,
  },
  {
    field: 'strategyDueDiligenceStatus',
    headerName: 'Due Diligence Status',
    ...textColumn,
    minWidth: 140,
    maxWidth: 190,
  },
];

export const managerStrategiesEsgDeiColumnDefs = [
  {
    suppressHeaderFilterButton: false,
    suppressHeaderMenuButton: false,
    field: 'investmentStrategyName',
    headerName: 'Strategy Name',
    cellRenderer: OpenManagerStrategy,
    sort: 'asc',
    ...textColumn,
    minWidth: 280,
    maxWidth: 540,
    flex: 1,
    suppressSizeToFit: true,
  },
  {
    field: 'dueDiligenceRating',
    headerName: 'Due Diligence Rating',
    minWidth: 120,
    maxWidth: 145,
    suppressSizeToFit: true,
  },
  ...esgDeiColumnDefs,
  {
    field: 'fplListName',
    headerName: 'Strategy Group',
    flex: 1,
    ...textColumn,
    minWidth: 250,
    maxWidth: 260,
  },
  {
    field: 'assetClass',
    headerName: 'Asset Class',
    ...textColumn,
    minWidth: 200,
    maxWidth: 550,
  },
  {
    field: 'betaGroup',
    headerName: 'Asset Group',
    ...textColumn,
    minWidth: 135,
    maxWidth: 150,
  },
  {
    field: 'strategyDueDiligenceStatus',
    headerName: 'Due Diligence Status',
    ...textColumn,
    minWidth: 140,
    maxWidth: 190,
  },
];

export const managerManagerActivitiesColumnDefs = [
  {
    suppressHeaderFilterButton: false,
    suppressHeaderMenuButton: false,
    field: 'subject',
    headerName: 'Subject',
    cellRenderer: OpenManagerNotesLink,
    ...textColumn,
    minWidth: 120,
  },
  {
    field: 'category',
    headerName: 'Category',
    minWidth: 80,
    maxWidth: 250,
    ...textColumn,
  },
  {
    field: 'date',
    headerName: 'Date',
    width: 100,
    sort: 'desc',
    ...dateColumn,
  },
  {
    field: 'newStatus',
    headerName: 'New Status',
    minWidth: 100,
    ...textColumn,
  },
];

export const PlansTableColumnDefs = [
  {
    field: 'planName',
    cellRenderer: OpenPlanLink,
    headerName: 'Plan Name',
    ...textColumn,
  },
  {
    headerName: 'Published',
    valueGetter: (params) =>
      params.data.planAdministratorEmail ? 'Published' : 'Unpublished',
    ...textColumn,
  },
  {
    headerName: 'Open in Backstop',
    cellRenderer: OpenBackstopLink,
    ...textColumn,
  },
  {
    field: 'entityType',
    headerName: 'Type',
    ...textColumn,
  },
];

export const EmployeePlansTableWithClientColumnDefs = [
  {
    field: 'clientName',
    headerName: 'Subject',
    rowGroup: true,
    hide: true,
    ...textColumn,
  },
  ...PlansTableColumnDefs,
];

export const PlansTableWithClientColumnDefs = [
  {
    field: 'clientName',
    headerName: 'Subject',
    rowGroup: true,
    hide: true,
    ...textColumn,
  },
  {
    field: 'planName',
    cellRenderer: OpenPlanLink,
    headerName: 'Plan Name',
    ...textColumn,
  },
  {
    field: 'entityType',
    headerName: 'Type',
    ...textColumn,
  },
];

export const PortfoliosValuesToPrintColumnDefs = [
  ...myManagersAssetColumnDefs,
  {
    field: 'liquidityName',
    headerName: 'Liquidity',
    width: 144,
    minWidth: 100,
    maxWidth: 400,
    suppressHeaderMenuButton: true,
    suppressHeaderFilterButton: true,
    suppressSizeToFit: true,
  },
  {
    field: 'inheritedPortfolioName',
    headerName: 'Legal Entity',
    type: 'rightAligned',
    headerClass: 'ag-header-cell-text-right',
    width: 160,
    minWidth: 160,
    maxWidth: 400,
  },
  {
    field: 'assetGroupChain',
    headerName: 'Derived From',
    type: 'rightAligned',
    headerClass: 'ag-header-cell-text-right',
    width: 160,
    minWidth: 160,
    maxWidth: 400,
  },
  {
    field: 'assetValue',
    headerName: 'Asset Value',
    type: 'rightAligned',
    headerClass: 'ag-header-cell-text-right',
    ...currencyColumn,
    width: 160,
    minWidth: 160,
    maxWidth: 400,
    aggFunc: 'sum',
  },
  {
    field: 'assetDate',
    headerName: 'As Of Date',
    width: 110,
    minWidth: 110,
    maxWidth: 110,
    ...dateColumn,
  },
];
